const DEFAULT_TIMEOUT_MS = 10000;

export const getImageDimensionsFromUrl = (
  url,
  timeoutMs = DEFAULT_TIMEOUT_MS
) => {
  return new Promise((resolve, reject) => {
    if (!url) {
      reject(new Error('Cannot load image dimensions without an URL'));
      return;
    }

    const img = new Image();
    let settled = false;
    let timeoutId;

    const settle = (callback) => {
      if (settled) {
        return;
      }

      settled = true;
      clearTimeout(timeoutId);
      img.onload = null;
      img.onerror = null;
      callback();
    };

    img.onload = () => {
      settle(() => {
        const height = img.height || img.naturalHeight;
        const width = img.width || img.naturalWidth;

        resolve({ img, height, width });
      });
    };

    img.onerror = () => {
      settle(() => {
        reject(new Error(`Cannot load image dimensions from ${url}`));
      });
    };

    timeoutId = setTimeout(() => {
      settle(() => {
        reject(new Error(`Timed out loading image dimensions from ${url}`));
      });
    }, timeoutMs);

    img.src = url;
  });
};
